import { __assign } from "tslib";
import { borderColor, borderRadius, borderStyle, borderWidth } from './longHandHelpers';
export var chevronStyles = function (_a, _b) {
    var theme = _a.theme, px2rem = _a.px2rem;
    var $isOpen = _b.$isOpen;
    var styles = {
        color: theme.spr.icon03,
        transition: 'transform 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        height: px2rem(10),
        width: px2rem(10),
    };
    if ($isOpen) {
        styles.color = theme.spr.icon04;
        styles.transform = 'rotate(180deg)';
    }
    return styles;
};
/**
 * This utility can be used when scroll track is clipping the border-radius of the container.
 * https://prod-gitlab.sprinklr.com/sprinklr/frontend/spaceweb/-/merge_requests/890#note_1765218
 */
export var transparentScrollbarStyles = {
    '::-webkit-scrollbar': {
        backgroundColor: 'transparent',
    },
    '::-webkit-scrollbar-thumb': __assign(__assign(__assign(__assign(__assign({ backgroundColor: 'darkgrey' }, borderRadius('8px')), borderWidth('4px')), borderStyle('solid')), borderColor('transparent')), { backgroundClip: 'padding-box' }),
};
export var getOutlineStyles = function (_a, props) {
    var theme = _a.theme;
    if (props === void 0) { props = {}; }
    // TODO: default value of outlineColor
    var _b = props.$outlineColor, $outlineColor = _b === void 0 ? theme.spr.focus01 : _b, _c = props.$outlineWidth, $outlineWidth = _c === void 0 ? '2px' : _c, _d = props.$outlineOffset, $outlineOffset = _d === void 0 ? '2px' : _d, _e = props.$outlineStyle, $outlineStyle = _e === void 0 ? 'solid' : _e;
    return {
        outlineStyle: $outlineStyle,
        outlineWidth: $outlineWidth,
        outlineColor: $outlineColor,
        outlineOffset: $outlineOffset,
    };
};
export var getFocusVisibleStyles = function (utils, props) {
    if (props === void 0) { props = {}; }
    return ({
        ':focus-visible': getOutlineStyles(utils, props),
    });
};
export var accessibilityStyles = {
    position: 'fixed',
    width: '0px',
    height: '0px',
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 0,
    padding: 0,
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    clipPath: 'inset(100%)',
};
